import { OnInit, Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { Router } from '@angular/router';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { DialogService } from '../../../dialog/dialog.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { DashboardService } from '../../services/dashboard.service';
import { UtilService } from 'src/modules/base/services/util.service';


@Component({
    selector: 'dashboard-quicksight',
    templateUrl: './quicksight.component.html',
    styleUrls: ['./quicksight.component.scss'],
    standalone: false
})
export class QuicksightComponent implements OnInit {
  @Input() data: any;
  
  @Output() configChanged: EventEmitter<any> = new EventEmitter();
  
  config: any = {};
  constructor(private baseService: BaseService, 
    private appService: AppService, 
    private loader: LoaderService,
    public router: Router,
    public dialogService:DialogService,
    public storage: StorageService,
    public alerts: AlertsService,
    public utilService:UtilService,
    public dashBoardService:DashboardService
    ) {
  }

  ngOnInit() {
    console.log("this.data===>",this.data);
    this.build();
  }

 
  build(){
    this.loader.showSpinner();
    this.dashBoardService.getWidgetData(this.data.widget_id,(data)=>{
      this.loader.hideSpinner();
      this.config.data = data;
      console.log("config===>",this.config.data)
      this.dashBoardService.getDashboardUrl(data.link,'quicksight',null,(url)=>{
        if(url){
          var org = this.appService.getOrganization();
          if(org && org.org_id != undefined && org.org_id){
            url += "#p.facilityid="+org.org_id
          }
          this.config.url = url;
        }
      });
    })
  }

 
 
  
}
